import { WebStorageStateStore } from 'oidc-client-ts'
import { ReactNode, createContext, useContext } from 'react'

const OidcConfigContext = createContext<OidcConfig | null>(null)

export type OidcConfig = {
  authority: string
  client_id: string
  redirect_uri: string
  response_type: string
  scope: string
  post_logout_redirect_uri: string
  loadUserInfo: boolean
  automaticSilentRenew: boolean
  userStore?: WebStorageStateStore
  extraQueryParams: {
    environment: string
    audience: string
    kc_idp_hint?: string
    connection?: string
  }
}

export const OidcConfigProvider = ({
  children,
  config
}: {
  children: ReactNode
  config: OidcConfig
}) => <OidcConfigContext.Provider value={config}>{children}</OidcConfigContext.Provider>

export const useOidcConfig = () => {
  const context = useContext(OidcConfigContext)
  if (!context) {
    throw new Error('useOidcConfig must be used within an OidcConfigProvider')
  }
  return context
}
